module.exports = __webpack_public_path__ + "public/images/movement.3f3b65f99fb2cf0be83f96ffff6b8d68.png";